// Simple global UI store to track active requests and error messages
// Components can subscribe to receive updates

const uiState = {
  activeRequests: 0,
  errorMessage: "",
  lastShowAt: 0,
};

const listeners = new Set();

function notify() {
  for (const listener of listeners) {
    try {
      listener({ ...uiState });
    } catch (_) {
      // no-op
    }
  }
}

export function subscribe(listener) {
  listeners.add(listener);
  // immediately send current state
  listener({ ...uiState });
  return () => listeners.delete(listener);
}

export function startRequest() {
  const now = Date.now();
  uiState.activeRequests += 1;
  if (uiState.activeRequests === 1) {
    uiState.lastShowAt = now;
  }
  notify();
}

export function endRequest() {
  const MIN_VISIBLE_MS = 400;
  const now = Date.now();
  const doEnd = () => {
    uiState.activeRequests = Math.max(0, uiState.activeRequests - 1);
    // Reset start timestamp when no more requests
    if (uiState.activeRequests === 0) uiState.lastShowAt = 0;
    notify();
  };
  if (uiState.activeRequests <= 1) {
    const elapsed = now - (uiState.lastShowAt || now);
    if (elapsed < MIN_VISIBLE_MS) {
      setTimeout(doEnd, MIN_VISIBLE_MS - elapsed);
    } else {
      doEnd();
    }
  } else {
    doEnd();
  }
}

export function setError(message) {
  uiState.errorMessage = message || "Đã xảy ra lỗi không xác định.";
  notify();
}

export function clearError() {
  uiState.errorMessage = "";
  notify();
}

const ui = {
  subscribe,
  startRequest,
  endRequest,
  setError,
  clearError,
};

export default ui;

